import { Text, Badge, Box } from "@chakra-ui/react";
import { LuTag } from "react-icons/lu";

export function BadgeCustom(props) {
  return (
    <Badge
      display="flex"
      alignItems={"center"}
      justifyContent="center"
      gap={2}
      px={"8px"}
      py={"3px"}
      border="solid 1px #DEE2E6"
      bg={"#1694991A"}
      textTransform="none"
    >
      <Box>
        <LuTag size={14} color="#6A6A6A" />
      </Box>
      <Text
        fontWeight={600}
        fontSize="14px"
        lineHeight="150%"
        color={`#6A6A6A`}
        whiteSpace="normal"
      >
        {props?.title} {props?.description}
      </Text>
    </Badge>
  );
}
